import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SectionTitle from './SectionTitle';
import { StyledPanel } from 'src/components/StyledPanel';
import NumberField from 'src/components/NumberField';
import { StyledFlex } from 'src/components/StyledFlex';

interface Props {
  averageDaysPerWeek: number | null;
  onChange: (value: string | number | null) => void;
  onSave: () => Promise<void>;
}

export default function HomeOfficeSection(props: Props) {
  const { t } = useTranslation('legacyGhg', {
    keyPrefix: 'employee-survey',
  });

  const { averageDaysPerWeek, onChange, onSave } = props;
  const [changed, setChanged] = useState(false);

  const handleChange = (value: string | number | null) => {
    onChange(value);
    setChanged(true);
  };

  return (
    <>
      <SectionTitle>{t('question2')}</SectionTitle>
      <StyledPanel>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            {t('homeoffice-label')}
          </Typography>
          <NumberField
            value={averageDaysPerWeek ?? ''}
            onChange={handleChange}
            size="small"
            inputProps={{ min: 0, max: 7, step: 0.1 }}
            sx={{ width: 120 }}
          />
        </Box>

        {changed && (
          <StyledFlex mt={2}>
            <div />
            <Button
              size="small"
              variant="contained"
              onClick={() => onSave().then(() => setChanged(false))}
            >
              {t('save')}
            </Button>
          </StyledFlex>
        )}
      </StyledPanel>
    </>
  );
}
